import { render, staticRenderFns } from "./ArtworkDimension.vue?vue&type=template&id=0bbc7bef&"
import script from "./ArtworkDimension.vue?vue&type=script&lang=js&"
export * from "./ArtworkDimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports